export default {"src":"__ASTRO_ASSET_IMAGE__BU3aXlxh__","width":16,"height":16,"format":"svg"}